import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import CityViews from './components/CityViews';
import WhyVenus from './components/WhyVenus';
import Stats from './components/Stats';
import SiteSelection from './components/SiteSelection';
import BusinessResources from './components/BusinessResources';
import Properties from './components/Properties';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import BoardMemberProfile from './pages/BoardMemberProfile';
import VenusHistory from './pages/VenusHistory';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function HomePage() {
  return (
    <div className="app-container">
      <Header />
      <main>
        <Hero />
        <CityViews />
        <WhyVenus />
        <Stats />
        <SiteSelection />
        <BusinessResources />
        <Properties />
        <AboutUs />
      </main>
      <Footer />
    </div>
  );
}

function ProfilePage() {
  return (
    <>
      <Header />
      <BoardMemberProfile />
      <Footer />
    </>
  );
}

function HistoryPage() {
  return (
    <>
      <Header />
      <VenusHistory />
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/profile/:id" element={<ProfilePage />} />
          <Route path="/history" element={<HistoryPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
